/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { Money } from '@/domain/controlling/entities';
import { Separator } from './Separator';
import { ContentWrapperCell } from './ContentWrapperCell';
import { useTranslation } from 'react-i18next';
import {
  AbsoluteNumberField,
  Abweichung,
  MoneyField,
} from '../../../components';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function AbsatzUmsatzPlanCell({
  absatzPlanWert,
  umsatzPlanWert,
  umsatzPrognoseWert,
  absatzPrognoseWert,
}: {
  absatzPlanWert: number | undefined;
  absatzPrognoseWert: number | undefined;
  umsatzPlanWert: Money | undefined;
  umsatzPrognoseWert: Money | undefined;
}) {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige } =
    useTagebuchEinstellungen(standortId);

  return (
    <ContentWrapperCell>
      {tagebuchAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
        <div className="flex gap-4 items-center">
          <div className="w-20">
            <MoneyField
              className="w-20"
              value={umsatzPlanWert}
              unit={
                umsatzPlanWert
                  ? t(`general.currency.${umsatzPlanWert.currency}`)
                  : t(`general.currency.EUR`)
              }
            />
          </div>
          {umsatzPrognoseWert?.amount === undefined ? null : (
            <Abweichung
              baseValue={umsatzPlanWert?.amount}
              comparisonValue={umsatzPrognoseWert.amount}
              tooltipMessage={t(
                'domain.controlling.umsatzplanung.planung.tooltip.abweichungZurPrognose',
              )}
              type="umsatz"
              unit={t('general.currency.EUR')}
            />
          )}
        </div>
      )}
      {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && <Separator />}
      {tagebuchAnzeige !== 'UMSATZ_PRODUKTIVITAET' && (
        <div className="flex gap-4 items-center">
          <AbsoluteNumberField
            className="w-20"
            value={absatzPlanWert}
            unit={t('domain.controlling.umsatzplanung.units.stueck')}
          />
          {absatzPrognoseWert === undefined ? null : (
            <Abweichung
              tooltipMessage={t(
                'domain.controlling.umsatzplanung.planung.tooltip.abweichungZurPrognose',
              )}
              baseValue={absatzPlanWert}
              comparisonValue={absatzPrognoseWert}
              type="absatz"
              unit={t('domain.controlling.umsatzplanung.units.stueck')}
            />
          )}
        </div>
      )}
    </ContentWrapperCell>
  );
}
